import { combineReducers } from "redux";

import playerprofileReducer from "./playerprofile";
import transactionDetailsReducer from "./transactionDetails";
import dashboardReducer from "./dashboard";

const rootReducer = combineReducers({
  playerprofile: playerprofileReducer,
  transactionDetails: transactionDetailsReducer,
  dashboard: dashboardReducer,
});

export default rootReducer;
